/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import get from 'lodash/get';
import Avatar from '../Avatar';
import Icon from '../Icon';
import Paper from '../Paper';
import { getPhoneWithoutUSCode } from '../../utils/getPhone';
import styles from './index.styl';

const ASSET_SIZE = 64;
const STRING_MAX_LENGTH = 57;

const ListItem = ({
  icon,
  image,
  title,
  subtitle,
  note,
  onClick,
  intro,
  className,
  titleIcon,
}) => (
  <Paper
    {...{ onClick }}
    styleName="item"
    className={classNames(className, { pointer: onClick })}
    rounded
  >
    <div className="mt2 mb3">
      <Choose>
        <When condition={icon}>
          <Icon name={icon} size={ASSET_SIZE} />
        </When>
        <Otherwise>
          <Avatar size={ASSET_SIZE} src={image} children={title} />
        </Otherwise>
      </Choose>
    </div>

    <p styleName="title" title={title}>
      {titleIcon && <Icon name={titleIcon} size={12} className="mb1 mr1" />}
      {getPhoneWithoutUSCode(title)}
    </p>
    <If condition={subtitle}>
      <p styleName="subtitle" title={subtitle} className="relative">
        {subtitle.substring(0, STRING_MAX_LENGTH)}
        {subtitle.length > STRING_MAX_LENGTH && '...'}
        <If condition={get(intro, 'invite')}>
          <span className={intro.invite} />
        </If>
      </p>
    </If>

    <If condition={note}>
      <p styleName="note">{note}</p>
    </If>
  </Paper>
);

ListItem.propTypes = {
  icon: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  note: PropTypes.string,
  onClick: PropTypes.func,
  intro: PropTypes.shape({
    invite: PropTypes.string,
  }),
  className: PropTypes.string,
  titleIcon: PropTypes.string,
};

export default CSSModules(ListItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/CircleList/ListItem.jsx